export default __webpack_public_path__ + "static/media/close.d5976415.svg";